/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AfterOrderMessage } from '../model';
// @ts-ignore
import { NewAfterOrderMessage } from '../model';
/**
 * AfterOrderMessageApiAfterOrderMessageDelete - axios parameter creator
 * Delete a single after-order-message record
 * @summary 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AfterOrderMessageApiAfterOrderMessageDeleteAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/after-order-message`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AfterOrderMessageApiAfterOrderMessageGet - axios parameter creator
 * Find all the after-order-message\'s records
 * @summary 
 * @param {number} [limit] Maximum number of results possible
 * @param {string} [sort] Sort according to a specific field.
 * @param {number} [start] Skip a specific number of entries (especially useful for pagination)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AfterOrderMessageApiAfterOrderMessageGetAxiosParamCreator (limit?: number, sort?: string, start?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/after-order-message`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (limit !== undefined) {
        localVarQueryParameter['_limit'] = limit;
    }

    if (sort !== undefined) {
        localVarQueryParameter['_sort'] = sort;
    }

    if (start !== undefined) {
        localVarQueryParameter['_start'] = start;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * AfterOrderMessageApiAfterOrderMessagePut - axios parameter creator
 * Update a single after-order-message record
 * @summary 
 * @param {NewAfterOrderMessage} newAfterOrderMessage 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function AfterOrderMessageApiAfterOrderMessagePutAxiosParamCreator (newAfterOrderMessage: NewAfterOrderMessage, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'newAfterOrderMessage' is not null or undefined
    assertParamExists('afterOrderMessagePut', 'newAfterOrderMessage', newAfterOrderMessage)
    const localVarPath = `/after-order-message`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newAfterOrderMessage, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for afterOrderMessageGet operation in AfterOrderMessageApi.
 * @export
 * @interface AfterOrderMessageApiAfterOrderMessageGetRequest
 */
export interface AfterOrderMessageApiAfterOrderMessageGetRequest {
    /**
     * Maximum number of results possible
     * @type {number}
     * @memberof AfterOrderMessageApiAfterOrderMessageGet
     */
    readonly limit?: number

    /**
     * Sort according to a specific field.
     * @type {string}
     * @memberof AfterOrderMessageApiAfterOrderMessageGet
     */
    readonly sort?: string

    /**
     * Skip a specific number of entries (especially useful for pagination)
     * @type {number}
     * @memberof AfterOrderMessageApiAfterOrderMessageGet
     */
    readonly start?: number
}

/**
 * Request parameters for afterOrderMessagePut operation in AfterOrderMessageApi.
 * @export
 * @interface AfterOrderMessageApiAfterOrderMessagePutRequest
 */
export interface AfterOrderMessageApiAfterOrderMessagePutRequest {
    /**
     * 
     * @type {NewAfterOrderMessage}
     * @memberof AfterOrderMessageApiAfterOrderMessagePut
     */
    readonly newAfterOrderMessage: NewAfterOrderMessage
}

/**
* Delete a single after-order-message record
* @summary 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AfterOrderMessageApiAfterOrderMessageDelete(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AfterOrderMessageApiAfterOrderMessageDeleteAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Find all the after-order-message\'s records
* @summary 
* @param {AfterOrderMessageApiAfterOrderMessageGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AfterOrderMessageApiAfterOrderMessageGet(requestParameters: AfterOrderMessageApiAfterOrderMessageGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AfterOrderMessageApiAfterOrderMessageGetAxiosParamCreator(requestParameters.limit, requestParameters.sort, requestParameters.start, options, configuration);
    const request: () => AxiosPromise<AfterOrderMessage> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Update a single after-order-message record
* @summary 
* @param {AfterOrderMessageApiAfterOrderMessagePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function AfterOrderMessageApiAfterOrderMessagePut(requestParameters: AfterOrderMessageApiAfterOrderMessagePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await AfterOrderMessageApiAfterOrderMessagePutAxiosParamCreator(requestParameters.newAfterOrderMessage, options, configuration);
    const request: () => AxiosPromise<AfterOrderMessage> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
